/**
 * @generated
 * This file was automatically generated and should not be manually edited.
 *
 * Auto-generated enum for: board_tasks.reflection
 *
 * To regenerate: npm run db:codegen
 * Any manual changes will be overwritten on next generation.
 */

/* eslint-disable */
// @ts-nocheck

/**
 * BoardTaskReflection enum representing allowed values for board_tasks.reflection
 */
export enum BoardTaskReflection {
  /** Understood */
  UNDERSTOOD = 'understood',
  /** Still Thinking */
  STILL_THINKING = 'still_thinking',
  /** Need Help */
  NEED_HELP = 'need_help',
}
